import React from "react";
import { object, func, bool } from "prop-types";
import { LazyLoadImages } from "@quintype/components";
import { StoryHeader } from "../../molecules";
import StoryElements from "../story-elements";
import "../../pages/story.m.css";
import { get } from "lodash";
import BookReviewCard from "../../molecules/BookReviewCard";
import StickySidebar from "../../../arrow/components/Atoms/StickySidebar";

import "./book-review.m.css";

const BookReview = ({ story, config, adWidget, adPlaceholder, hasAccess, recommendedStories, magazineDetails }) => {
  const { headline, authors, "published-at": publishTime = "" } = story;

  const showBookReview = () => {
    const metadata = get(story, ["metadata"]);
    const {
      publication = "",
      author = "",
      "book-headline": bookHeadline = "",
      price = "",
      "page-count": pageCount = "",
      "book-cover-image": bookCoverImage = "",
      "onclick-url": onclickUrl = "",
    } = metadata;

    return publication || author || bookHeadline || price || pageCount || bookCoverImage || onclickUrl;
  };
  const isValidBookReview =
    Boolean(story?.metadata?.author?.trim()) &&
    Boolean(story?.metadata?.publication?.trim()) &&
    Boolean(story?.metadata?.["book-cover-image"]?.trim()) &&
    Boolean(story?.metadata?.["book-headline"]?.trim());

  return (
    <div styleName="story-template-container" className="story-holder">
      <StoryHeader
        story={story}
        headline={headline}
        storyAuthorData={authors}
        publishTime={publishTime}
        readTime={story?.["read-time"]}
        magazineDetails={magazineDetails}
        showBookReview={showBookReview()}
        isValidBookReview={isValidBookReview}
      />
      <div className="story-elements">
        <div className="text-container" styleName={`${isValidBookReview ? "book-review-text-container" : "no-widget"}`}>
          <LazyLoadImages>
            {showBookReview() && isValidBookReview && (
              <StickySidebar>
                <BookReviewCard isSticky={true} reviewInfo={story.metadata} />
              </StickySidebar>
            )}
            <StoryElements
              story={story}
              cards={story.cards}
              recommendedStories={recommendedStories}
              isStickyBookReview={!!(showBookReview() && isValidBookReview)}
              config={config}
            />
          </LazyLoadImages>
        </div>
      </div>
    </div>
  );
};
BookReview.propTypes = {
  story: object,
  config: object,
  adWidget: func,
  adPlaceholder: object,
  hasAccess: bool,
};
export default BookReview;
